import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import FormatTime from "../../helpers/FormatTime";
import InputComboDzien from "../../helpers/InputComboDzien";
import InputPagger from "../../helpers/InputPagger";


import input_check from "../../input_check.png"
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import EatNew from "./EatNew";
import MenuTable from "../../helpers/MenuTable";


function Eat(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),         
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,   
        dzien: '_x_',
        limit: 50,
        page: 1,
        pages: 1,
        show: true,  
    });
    const [tab, setTab] = useState(null);  


    
    const tabRefPDF = useRef(0);
    const tabRefCSVPrint = useRef(0);


    
    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {

        props.mainView.writeFilter('p_imie_nazwisko', '');


        setFilterParam({
            p_imie_nazwisko: '',            
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,                    
            dzien: '_x_',
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }


    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

         props.mainView.writeFilter(filedName, val);
     }



     const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }





    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_emps,eat', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);   
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );                               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }






    const goDeleteOK = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1_emps,eat_remove', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getTab();  
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteOK(id);
                        //--------
        } );
    }





    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }




        var sumS = 0;
        var sumO = 0;
        var sumP = 0;
        var sumI = 0;


        for(var k=0; k<tab.length; k++)
        {
                        
                sumS         =  sumS +  parseInt( tab[k].sniadanie );
                sumO         =  sumO +  parseInt( tab[k].obiad );
                sumP         =  sumP +  parseInt( tab[k].podwieczorek );
                sumI         =  sumI +  parseInt( tab[k].inne );    
        }




        return  <div className="view_content">


                             <div className="table_filter">
                                    
                                            

                                    <div className="filter_controll">   
                                        <label>Rok: </label>                             
                                        <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                                    </div> 

                                    <div className="filter_controll">   
                                        <label>Miesiąc: </label>                             
                                        <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                                    </div> 

                                    
                                    <div className="filter_controll">   
                                            <label>Dzień: </label>                             
                                            <InputComboDzien   userData={props.userData}  mainView={props.mainView}  rok={filterParam.rok}  miesiac={filterParam.miesiac}  value={filterParam.dzien}   valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={": "}  noempty="0"   />
                                    </div>

                                    {
                                           props.userData.type == "DYREKTOR"  &&
                                           <Fragment>
                                                <div className="filter_controll">   
                                                        <label>Pracownik: </label>                             
                                                        <InputTextAlpha   userData={props.userData} value={filterParam.p_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="p_imie_nazwisko" placeholder={"Pracownik: "}   />
                                                    </div> 
                                           </Fragment>
                                    }
                                   


                                    <div className="filter_btn">
                                        
                                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                    </div>

                            </div>

                            <div className="tip">
                                    Zamówienia dotyczące posiłków dla pracowników są wysyłane do cateringu wg. ustawień placówki.
                            </div>


                            <div className="table_widget">
  
                                    <EatNew userData={props.userData} mainView={props.mainView}  onSuccess={getTab} />                      

                                    <InputPagger filter={filterParam}  onChange={onChangePagger}  />

                                    &nbsp;&nbsp;                              

                                    <HtmlToPDF tabRef={tabRefPDF} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Rejestr" />   

                                    <Csv tabRef={tabRefCSVPrint} />

                                    <Print tabRef={tabRefCSVPrint} />
                            </div>




                            <div className="gohide" ref={tabRefPDF}>

                                   <h3>Rejestr {filterParam.rok + "-" + filterParam.miesiac }</h3>   

                                   <table className="table" ref={tabRefCSVPrint}>            

                                                        <thead>
                                                                <tr className="header">                                                                
                                                                    <td className="td_left gocenter">LP</td>     
                                                                    <td>Osoba</td>  
                                                                    <td>Dzień</td>                                                                                                                
                                                                    <td>Śniadanie</td>                                                                                                                
                                                                    <td>Obiad</td>                                                                                                                
                                                                    <td>Podwieczorek</td>                                                                                                                
                                                                    <td>Inne</td>                                                                                                                
                                                                    <td>Info. dodatkowe</td>                                                                                                                
                                                                </tr>
                                                        </thead>

                                                        <tbody>
                                                            {
                                                                tab.map( (row, ix) => {

                                                                    var rowStyle = " row ";
                                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                    return <tr className={rowStyle} key={ix}>                                                                
                                                                        <td className="td_left gocenter">{ix+1}</td>     
                                                                        <td className="gocenter">{row.g.nazwisko + " " + row.g.imie}</td>                                                                                                                          
                                                                        <td className="gocenter">{row.dzien}</td>                                                                                                                          
                                                                        <td className="gocenter">
                                                                            {
                                                                            row.sniadanie == 1 && 
                                                                            <Fragment>Tak</Fragment>
                                                                            }
                                                                            {
                                                                            row.sniadanie == 0 && 
                                                                            <Fragment>Nie</Fragment>
                                                                            }
                                                                        </td>         
                                                                        <td className="gocenter">
                                                                            {
                                                                            row.obiad == 1 && 
                                                                            <Fragment>Tak</Fragment>
                                                                            }
                                                                            {
                                                                            row.obiad == 0 && 
                                                                            <Fragment>Nie</Fragment>
                                                                            }
                                                                        </td>                                                                                                                          
                                                                        <td className="gocenter">
                                                                        {
                                                                            row.podwieczorek == 1 && 
                                                                            <Fragment>Tak</Fragment>
                                                                            }
                                                                            {
                                                                            row.podwieczorek == 0 && 
                                                                            <Fragment>Nie</Fragment>
                                                                            }
                                                                        </td>                                                                                                                          
                                                                        <td className="gocenter">
                                                                            {
                                                                            row.inne == 1 && 
                                                                               <Fragment>Tak</Fragment>
                                                                            }
                                                                            {
                                                                            row.inne == 0 && 
                                                                                <Fragment>Nie</Fragment>
                                                                            }
                                                                        </td>                                                                                                                          
                                                                        <td className="gocenter">{row.informacje_dodatkowe}</td>                                                                                                                          
                                                                    </tr>


                                                                } )
                                                            }

                                                                <tr>                                                                
                                                                    <td></td>     
                                                                    <td></td>  
                                                                    <td></td>                                                                                                                
                                                                    <td className="gobold gocenter">{sumS}</td>                                                                                                                
                                                                    <td className="gobold gocenter">{sumO}</td>                                                                                                                
                                                                    <td className="gobold gocenter">{sumP}</td>                                                                                                                
                                                                    <td className="gobold gocenter">{sumI}</td>                                                                                                                
                                                                    <td></td>                                                                                                                
                                                                </tr>
                                                        </tbody>

                                                        </table>

                            </div>


             
                            <div className=" bg_center">

                                    <div className="scorll_x">
                                            <table className="table">            

                                                <thead>
                                                        <tr className="header">                                                                
                                                            <td className="td_left gocenter">LP</td>     
                                                            <td>Osoba</td>  
                                                            <td>Dzień</td>                                                                                                                
                                                            <td>Śniadanie</td>                                                                                                                
                                                            <td>Obiad</td>                                                                                                                
                                                            <td>Podwieczorek</td>                                                                                                                
                                                            <td>Inne</td>                                                                                                                
                                                            <td className="td_right">Info. dodatkowe</td>                                                                                                                
                                                            <td className="td_option"> </td>                                                                                                                
                                                        </tr>
                                                </thead>

                                                <tbody>
                                                    {
                                                        tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            return <tr className={rowStyle} key={ix}  >                                                                
                                                                <td className="td_left gocenter">{ix+1}</td>     
                                                                <td className="gocenter">{row.g.nazwisko + " " + row.g.imie}</td>                                                                                                                          
                                                                <td className="gocenter">{row.dzien}</td>                                                                                                                          
                                                                <td className="gocenter">
                                                                    {
                                                                       row.sniadanie == 1 && 
                                                                       <img src={input_check} />
                                                                    }
                                                                    {
                                                                       row.sniadanie == 0 && 
                                                                       <span>-</span>
                                                                    }
                                                                </td>         
                                                                <td className="gocenter">
                                                                    {
                                                                       row.obiad == 1 && 
                                                                       <img src={input_check} />
                                                                    }
                                                                    {
                                                                       row.obiad == 0 && 
                                                                       <span>-</span>
                                                                    }
                                                                </td>                                                                                                                          
                                                                <td className="gocenter">
                                                                {
                                                                       row.podwieczorek == 1 && 
                                                                       <img src={input_check} />
                                                                    }
                                                                    {
                                                                       row.podwieczorek == 0 && 
                                                                       <span>-</span>
                                                                    }
                                                                </td>                                                                                                                          
                                                                <td className="gocenter">
                                                                    {
                                                                       row.inne == 1 && 
                                                                       <img src={input_check} />
                                                                    }
                                                                    {
                                                                       row.inne == 0 && 
                                                                       <span>-</span>
                                                                    }
                                                                </td>                                                                                                                          
                                                                <td className="gocenter">{row.informacje_dodatkowe}</td>                                                                                                                          

                                                                 <MenuTable>
                                                                        <ul>                                             
                                                                             {
                                                                                 props.userData.type == "DYREKTOR"  &&
                                                                                 <li onClick={goDelete} v="delete" id={row.id} >usuń</li>
                                                                             }  
                                                                              {
                                                                                 props.userData.type != "DYREKTOR"  &&
                                                                                 <li   >usuń [BLOKADA]</li>
                                                                             }                                                                                                 
                                                                        </ul>
                                                                 </MenuTable>  

                                                            </tr>


                                                        } )
                                                    }
 
                                                        <tr>                                                                
                                                            <td></td>     
                                                            <td></td>  
                                                            <td></td>                                                                                                                
                                                            <td className="gobold gocenter">{sumS}</td>                                                                                                                
                                                            <td className="gobold gocenter">{sumO}</td>                                                                                                                
                                                            <td className="gobold gocenter">{sumP}</td>                                                                                                                
                                                            <td className="gobold gocenter">{sumI}</td>                                                                                                                
                                                            <td></td>                                                                                                                                                                         
                                                        </tr>
                                                </tbody>

                                            </table>
                                    </div>
                            </div>


        </div>
}



export default Eat;